import { get } from ".";

export function paginateCategories(id?: number) {
  return get("knowledgebase/category", id ? { parent_id: id } : {});
}

export function paginateArticles(id: number) {
  return get(`knowledgebase/category/${id}`);
}
